import { render } from "./CKEditor.vue?vue&type=template&id=0a039ccf&scoped=true"
import script from "./CKEditor.vue?vue&type=script&lang=js"
export * from "./CKEditor.vue?vue&type=script&lang=js"

import "./CKEditor.vue?vue&type=style&index=0&id=0a039ccf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a039ccf"]])

export default __exports__